import { FC } from 'react'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'
import { SimulationCloseProps as Props } from './types'
import styles from './SimulationClose.module.scss'
import Button from 'components/button/Button'

const SimulationClose: FC<Props> = ({ isOpen, simulationCompleted, onRequestClose, onRequestContinue }) => {
  // i18n
  const { t } = useTranslation('simulation')

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          zIndex: 100,
          background: 'rgba(0, 0, 0, 0.85)'
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }
      }}
    >
      <p>
        {simulationCompleted
          ? t('cancelCompletedSimulation', 'Ben je zeker dat je je prijs niet in je mailbox wil ontvangen?')
          : t('cancelSimulation', 'Ben je zeker dat je de simulatie wilt annuleren?')}
      </p>
      <Button onClick={() => onRequestContinue()} withGradient>
        {simulationCompleted
          ? t('cancelCompletedSimulationContinue', 'Nee, ik wil mijn prijs ook ontvangen via e-mail')
          : t('cancelSimulationContinue', 'Nee, ik wil verder berekenen')}
      </Button>
      <br />
      <a href="#" onClick={() => onRequestClose()} className={styles['close-simulation']}>
        {simulationCompleted
          ? t('cancelCompletedSimulationConfirm', 'Ja, sluit de simulatie en toon mijn resultaat')
          : t('cancelSimulationConfirm', 'Ja, sluit de simulatie')}
      </a>
    </Modal>
  )
}

export default SimulationClose
